export default {"src":"/_next/static/media/sneakEvents.9fc4a1cd.svg","height":382,"width":320};